export default __webpack_public_path__ + "static/media/firstbank.95551633.png";